export default __webpack_public_path__ + "static/media/22.a3cb2c77.jpg";